<template>
  <base-slide-over ref="slideover" :title="isNew === true ? 'New Product' : 'Edit Product'" size="xl" style="z-index: 10000">
    <base-form ref="productForm" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <base-text-field label="Product Name" placeholder="Enter product name" v-model="businessItemCategory.name" class="tw-mt-3" required :maxLength="255" />
      <base-text-field
        label="Short Description"
        placeholder="Enter a short description of the product"
        v-model="businessItemCategory.descriptionShort"
        class="tw-mt-3"
        required
        :maxLength="255"
      />
      <base-textarea
        label="Long Description"
        placeholder="Enter a longer description of the product"
        v-model="businessItemCategory.descriptionLong"
        class="tw-mt-3"
        required
        :maxLength="1020"
      />
      <base-select label="Product Group" placeholder="Select a group" :options="productGroups" v-model="businessItemCategory.productGroup" />
      <base-text-field
        v-if="businessItemCategory.productGroup === 'new group'"
        label="New Product Group"
        placeholder="Enter new product group"
        v-model="businessItemCategory.newProductGroup"
        :rules="[() => (this.businessItemCategory.productGroup === 'new group' && this.businessItemCategory.newProductGroup !== null) || 'Please enter a new group name']"
        :maxLength="255"
        class="tw-mt-3"
      />
      <base-currency-input class="tw-mt-5" label="Retail Price" :int-value.sync="businessItemCategory.retailPriceCents" v-model="businessItemCategory.retailPrice" required />
      <base-radio-group :value="businessItemCategory.status" class="tw-space-x-6 tw-flex" required>
        <base-radio value="active" name="status" v-model="businessItemCategory.status">Active</base-radio>
        <base-radio value="inactive" name="status" v-model="businessItemCategory.status">Inactive</base-radio>
        <base-radio value="archived" name="status" v-model="businessItemCategory.status">Archived</base-radio>
      </base-radio-group>
    </base-form>
    <inline-error id="business-plan-error" :title="errorTitle" :message="errorMessage" :error="error" />
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-3" @click="close()"> Cancel </base-button>
        <base-button :loading="isSaving" :disabled="!isFormValid" class="tw-w-auto" @click="save"> Save </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessItemCategorySlideover",
  components: { InlineError },
  data() {
    return {
      isFormValid: true,
      isSaving: false,
      isNew: false,
      businessId: null,
      businessItemCategory: {
        businessId: null,
        businessItemCategoryId: null,
        name: null,
        descriptionShort: null,
        descriptionLong: null,
        retailPriceCurrency: "USD",
        retailPriceCents: 0,
        retailPrice: 0,
        status: "active",
        type: "product",
        productGroup: null,
        newProductGroup: null,
        taxable: false,
      },
      productGroups: [],
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  methods: {
    reset() {
      this.isNew = false;
      this.businessId = null;
      this.businessItemCategory = {
        businessId: null,
        businessItemCategoryId: null,
        name: null,
        descriptionShort: null,
        descriptionLong: null,
        retailPriceCurrency: "USD",
        retailPriceCents: 0,
        retailPrice: 0,
        status: "active",
        type: "product",
        productGroup: null,
        newProductGroup: null,
        taxable: false,
      };
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    show(businessId, businessItemCategory, productGroups) {
      this.reset();
      this.businessId = businessId;
      this.productGroups = productGroups;

      if (!businessItemCategory) this.isNew = true;

      if (businessItemCategory) {
        this.businessItemCategory.businessId = businessId;
        this.businessItemCategory.businessItemCategoryId = businessItemCategory.businessItemCategoryId;
        this.businessItemCategory.name = businessItemCategory.name;
        this.businessItemCategory.descriptionShort = businessItemCategory.descriptionShort;
        this.businessItemCategory.descriptionLong = businessItemCategory.descriptionLong;
        this.businessItemCategory.retailPriceCurrency = businessItemCategory.retailPriceCurrency;
        this.businessItemCategory.retailPrice = businessItemCategory.retailPriceCents;
        this.businessItemCategory.status = businessItemCategory.status;
        this.businessItemCategory.type = businessItemCategory.type;
        this.businessItemCategory.productGroup = businessItemCategory.productGroup;
        this.businessItemCategory.taxable = businessItemCategory.taxable;
      }

      this.$refs.slideover.show();
    },
    close() {
      this.$refs.slideover.hide();
    },
    save() {
      this.isSaving = true;
      if (!this.$refs.productForm.validate()) return;

      if (this.isNew) {
        this.$axios
          .post(`/businesses/${this.businessId}/item-categories`, {
            businessId: this.businessId,
            name: this.businessItemCategory.name,
            descriptionShort: this.businessItemCategory.descriptionShort,
            descriptionLong: this.businessItemCategory.descriptionLong,
            retailPriceCurrency: this.businessItemCategory.retailPriceCurrency,
            retailPriceCents: this.businessItemCategory.retailPriceCents,
            status: this.businessItemCategory.status,
            taxable: this.businessItemCategory.taxable,
            type: this.businessItemCategory.type,
            productGroup: this.businessItemCategory.newProductGroup !== null ? this.businessItemCategory.newProductGroup : this.businessItemCategory.productGroup,
          })
          .then(() => {
            this.close();
            this.$emit("save");
            this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Product/Service Added", message: "Product/Service " + this.businessItemCategory.name + " was created successfully" });
          })
          .catch((err) => {
            this.errorTitle = `Failed to create ${this.businessItemCategory.name}`;
            this.errorMessage = `${this.businessItemCategory.name} was not able to be created. Please try again.`;
            this.error = err;
          })
          .finally(() => {
            this.isSaving = false;
          });
      } else {
        this.$axios
          .put(`/businesses/${this.businessId}/item-categories/${this.businessItemCategory.businessItemCategoryId}`, {
            businessItemCategoryId: this.businessItemCategory.businessItemCategoryId,
            businessId: this.businessId,
            name: this.businessItemCategory.name,
            descriptionShort: this.businessItemCategory.descriptionShort,
            descriptionLong: this.businessItemCategory.descriptionLong,
            retailPriceCurrency: this.businessItemCategory.retailPriceCurrency,
            retailPriceCents: this.businessItemCategory.retailPriceCents,
            status: this.businessItemCategory.status,
            taxable: this.businessItemCategory.taxable,
            type: this.businessItemCategory.type,
            productGroup: this.businessItemCategory.newProductGroup !== null ? this.businessItemCategory.newProductGroup : this.businessItemCategory.productGroup,
          })
          .then(() => {
            this.close();
            this.$emit("save");
            this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Product/Service Updated", message: "Product/Service " + this.businessItemCategory.name + " was updated successfully" });
          })
          .catch((err) => {
            this.errorTitle = `Failed to update ${this.businessItemCategory.name}`;
            this.errorMessage = `${this.businessItemCategory.name} was not able to be updated. Please try again.`;
            this.error = err;
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
  },
};
</script>
